/**
 * 聊天界面表情输入界面
 * 需要注意的是， TUIKit 里面的表情包都是有版权限制的，购买的 IM 服务不包括表情包的使用权，请在上线的时候替换成自己的表情包，否则会面临法律风险
 * 黄脸表情为腾讯云版权所有，如要使用需获得授权，请通过以下链接联系我们。
 *
 * Emoji input interface in the chat screen.
 * It should be noted that the emoticons in TUIKit are copyrighted. The purchased IM service does not include the right to use the emoticons. Please replace
 * them with your own emoticons when you go online, otherwise you will face legal risks.
 * The yellow face emoji is copyrighted by Tencent Cloud. To use it, authorization is required. Please contact us through the following link.
 *
 * https://cloud.tencent.com/document/product/269/59590
 */
export const emojiBaseUrl = 'https://web.sdk.qcloud.com/im/assets/emoji/'
export const emojiUrlMapping: any = {
  '[NO]': 'emoji_0@2x.png',
  '[OK]': 'emoji_1@2x.png',
  '[下雨]': 'emoji_2@2x.png',
  '[么么哒]': 'emoji_3@2x.png',
  '[乒乓]': 'emoji_4@2x.png',
  '[便便]': 'emoji_5@2x.png',
  '[信封]': 'emoji_6@2x.png',
  '[偷笑]': 'emoji_7@2x.png',
  '[傲慢]': 'emoji_8@2x.png',
  '[再见]': 'emoji_9@2x.png',
  '[冷汗]': 'emoji_10@2x.png',
  '[凋谢]': 'emoji_11@2x.png',
  '[刀]': 'emoji_12@2x.png',
  '[删除]': 'emoji_13@2x.png',
  '[勾引]': 'emoji_14@2x.png',
  '[发呆]': 'emoji_15@2x.png',
  '[发抖]': 'emoji_16@2x.png',
  '[可怜]': 'emoji_17@2x.png',
  '[可爱]': 'emoji_18@2x.png',
  '[右哼哼]': 'emoji_19@2x.png',
  '[右太极]': 'emoji_20@2x.png',
  '[右车头]': 'emoji_21@2x.png',
  '[吐]': 'emoji_22@2x.png',
  '[吓]': 'emoji_23@2x.png',
  '[咒骂]': 'emoji_24@2x.png',
  '[咖啡]': 'emoji_25@2x.png',
  '[啤酒]': 'emoji_26@2x.png',
  '[嘘]': 'emoji_27@2x.png',
  '[回头]': 'emoji_28@2x.png',
  '[困]': 'emoji_29@2x.png',
  '[坏笑]': 'emoji_30@2x.png',
  '[多云]': 'emoji_31@2x.png',
  '[大兵]': 'emoji_32@2x.png',
  '[大哭]': 'emoji_33@2x.png',
  '[太阳]': 'emoji_34@2x.png',
  '[奋斗]': 'emoji_35@2x.png',
  '[奶瓶]': 'emoji_36@2x.png',
  '[委屈]': 'emoji_37@2x.png',
  '[害羞]': 'emoji_38@2x.png',
  '[尴尬]': 'emoji_39@2x.png',
  '[左哼哼]': 'emoji_40@2x.png',
  '[左太极]': 'emoji_41@2x.png',
  '[左车头]': 'emoji_42@2x.png',
  '[差劲]': 'emoji_43@2x.png',
  '[弱]': 'emoji_44@2x.png',
  '[强]': 'emoji_45@2x.png',
  '[彩带]': 'emoji_46@2x.png',
  '[彩球]': 'emoji_47@2x.png',
  '[得意]': 'emoji_48@2x.png',
  '[微笑]': 'emoji_49@2x.png',
  '[心碎了]': 'emoji_50@2x.png',
  '[快哭了]': 'emoji_51@2x.png',
  '[怄火]': 'emoji_52@2x.png',
  '[怒]': 'emoji_53@2x.png',
  '[惊恐]': 'emoji_54@2x.png',
  '[惊讶]': 'emoji_55@2x.png',
  '[憨笑]': 'emoji_56@2x.png',
  '[手枪]': 'emoji_57@2x.png',
  '[打哈欠]': 'emoji_58@2x.png',
  '[抓狂]': 'emoji_59@2x.png',
  '[折磨]': 'emoji_60@2x.png',
  '[抠鼻]': 'emoji_61@2x.png',
  '[抱抱]': 'emoji_62@2x.png',
  '[抱拳]': 'emoji_63@2x.png',
  '[拳头]': 'emoji_64@2x.png',
  '[挥手]': 'emoji_65@2x.png',
  '[握手]': 'emoji_66@2x.png',
  '[撇嘴]': 'emoji_67@2x.png',
  '[擦汗]': 'emoji_68@2x.png',
  '[敲打]': 'emoji_69@2x.png',
  '[晕]': 'emoji_70@2x.png',
  '[月亮]': 'emoji_71@2x.png',
  '[棒棒糖]': 'emoji_72@2x.png',
  '[汽车]': 'emoji_73@2x.png',
  '[沙发]': 'emoji_74@2x.png',
  '[流汗]': 'emoji_75@2x.png',
  '[流泪]': 'emoji_76@2x.png',
  '[激动]': 'emoji_77@2x.png',
  '[灯泡]': 'emoji_78@2x.png',
  '[炸弹]': 'emoji_79@2x.png',
  '[熊猫]': 'emoji_80@2x.png',
  '[爆筋]': 'emoji_81@2x.png',
  '[爱你]': 'emoji_82@2x.png',
  '[爱心]': 'emoji_83@2x.png',
  '[爱情]': 'emoji_84@2x.png',
  '[猪头]': 'emoji_85@2x.png',
  '[猫咪]': 'emoji_86@2x.png',
  '[献吻]': 'emoji_87@2x.png',
  '[玫瑰]': 'emoji_88@2x.png',
  '[瓢虫]': 'emoji_89@2x.png',
  '[疑问]': 'emoji_90@2x.png',
  '[白眼]': 'emoji_91@2x.png',
  '[皮球]': 'emoji_92@2x.png',
  '[睡觉]': 'emoji_93@2x.png',
  '[磕头]': 'emoji_94@2x.png',
  '[示爱]': 'emoji_95@2x.png',
  '[礼品袋]': 'emoji_96@2x.png',
  '[礼物]': 'emoji_97@2x.png',
  '[篮球]': 'emoji_98@2x.png',
  '[米饭]': 'emoji_99@2x.png',
  '[糗大了]': 'emoji_100@2x.png',
  '[红双喜]': 'emoji_101@2x.png',
  '[红灯笼]': 'emoji_102@2x.png',
  '[纸巾]': 'emoji_103@2x.png',
  '[胜利]': 'emoji_104@2x.png',
  '[色]': 'emoji_105@2x.png',
  '[药]': 'emoji_106@2x.png',
  '[菜刀]': 'emoji_107@2x.png',
  '[蛋糕]': 'emoji_108@2x.png',
  '[蜡烛]': 'emoji_109@2x.png',
  '[街舞]': 'emoji_110@2x.png',
  '[衰]': 'emoji_111@2x.png',
  '[西瓜]': 'emoji_112@2x.png',
  '[调皮]': 'emoji_113@2x.png',
  '[象棋]': 'emoji_114@2x.png',
  '[跳绳]': 'emoji_115@2x.png',
  '[跳跳]': 'emoji_116@2x.png',
  '[车厢]': 'emoji_117@2x.png',
  '[转圈]': 'emoji_118@2x.png',
  '[鄙视]': 'emoji_119@2x.png',
  '[酷]': 'emoji_120@2x.png',
  '[钞票]': 'emoji_121@2x.png',
  '[钻戒]': 'emoji_122@2x.png',
  '[闪电]': 'emoji_123@2x.png',
  '[闭嘴]': 'emoji_124@2x.png',
  '[闹钟]': 'emoji_125@2x.png',
  '[阴险]': 'emoji_126@2x.png',
  '[难过]': 'emoji_127@2x.png',
  '[雨伞]': 'emoji_128@2x.png',
  '[青蛙]': 'emoji_129@2x.png',
  '[面条]': 'emoji_130@2x.png',
  '[鞭炮]': 'emoji_131@2x.png',
  '[风车]': 'emoji_132@2x.png',
  '[飞吻]': 'emoji_133@2x.png',
  '[飞机]': 'emoji_134@2x.png',
  '[饥饿]': 'emoji_135@2x.png',
  '[香蕉]': 'emoji_136@2x.png',
  '[骷髅]': 'emoji_137@2x.png',
  '[麦克风]': 'emoji_138@2x.png',
  '[麻将]': 'emoji_139@2x.png',
  '[鼓掌]': 'emoji_140@2x.png',
  '[龇牙]': 'emoji_141@2x.png'
}

export const emojiNameMapping: any = {
  '[龇牙]':'[龇牙]',
  '[调皮]':'[调皮]',
  '[流汗]':'[流汗]',
  '[偷笑]':'[偷笑]',
  '[再见]':'[再见]',
  '[敲打]':'[敲打]',
  '[擦汗]':'[擦汗]',
  '[猪头]':'[猪头]',
  '[玫瑰]':'[玫瑰]',
  '[流泪]':'[流泪]',
  '[大哭]':'[大哭]',
  '[嘘]':'[嘘]',
  '[酷]':'[酷]',
  '[抓狂]':'[抓狂]',
  '[委屈]':'[委屈]',
  '[便便]':'[便便]',
  '[炸弹]':'[炸弹]',
  '[菜刀]':'[菜刀]',
  '[可爱]':'[可爱]',
  '[色]':'[色]',
  '[害羞]':'[害羞]',
  '[得意]':'[得意]',
  '[吐]':'[吐]',
  '[微笑]':'[微笑]',
  '[怒]':'[怒]',
  '[尴尬]':'[尴尬]',
  '[惊恐]':'[惊恐]',
  '[冷汗]':'[冷汗]',
  '[爱心]':'[爱心]',
  '[示爱]':'[示爱]',
  '[白眼]':'[白眼]',
  '[傲慢]':'[傲慢]',
  '[难过]':'[难过]',
  '[惊讶]':'[惊讶]',
  '[疑问]':'[疑问]',
  '[困]':'[困]',
  '[么么哒]':'[么么哒]',
  '[憨笑]':'[憨笑]',
  '[爱情]':'[爱情]',
  '[衰]':'[衰]',
  '[撇嘴]':'[撇嘴]',
  '[阴险]':'[阴险]',
  '[奋斗]':'[奋斗]',
  '[发呆]':'[发呆]',
  '[右哼哼]':'[右哼哼]',
  '[抱抱]':'[抱抱]',
  '[坏笑]':'[坏笑]',
  '[飞吻]':'[飞吻]',
  '[鄙视]':'[鄙视]',
  '[晕]':'[晕]',
  '[大兵]':'[大兵]',
  '[可怜]':'[可怜]',
  '[强]':'[强]',
  '[弱]':'[弱]',
  '[握手]':'[握手]',
  '[胜利]':'[胜利]',
  '[抱拳]':'[抱拳]',
  '[凋谢]':'[凋谢]',
  '[米饭]':'[米饭]',
  '[蛋糕]':'[蛋糕]',
  '[西瓜]':'[西瓜]',
  '[啤酒]':'[啤酒]',
  '[瓢虫]':'[瓢虫]',
  '[勾引]':'[勾引]',
  '[OK]':'[OK]',
  '[爱你]':'[爱你]',
  '[咖啡]':'[咖啡]',
  '[月亮]':'[月亮]',
  '[刀]':'[刀]',
  '[发抖]':'[发抖]',
  '[差劲]':'[差劲]',
  '[拳头]':'[拳头]',
  '[心碎了]':'[心碎了]',
  '[太阳]':'[太阳]',
  '[礼物]':'[礼物]',
  '[皮球]':'[皮球]',
  '[骷髅]':'[骷髅]',
  '[挥手]':'[挥手]',
  '[闪电]':'[闪电]',
  '[饥饿]':'[饥饿]',
  '[咒骂]':'[咒骂]',
  '[折磨]':'[折磨]',
  '[抠鼻]':'[抠鼻]',
  '[鼓掌]':'[鼓掌]',
  '[糗大了]':'[糗大了]',
  '[左哼哼]':'[左哼哼]',
  '[打哈欠]':'[打哈欠]',
  '[快哭了]':'[快哭了]',
  '[吓]':'[吓]',
  '[篮球]':'[篮球]',
  '[乒乓]':'[乒乓]',
  '[NO]':'[NO]',
  '[跳跳]':'[跳跳]',
  '[怄火]':'[怄火]',
  '[转圈]':'[转圈]',
  '[磕头]':'[磕头]',
  '[回头]':'[回头]',
  '[跳绳]':'[跳绳]',
  '[激动]':'[激动]',
  '[街舞]':'[街舞]',
  '[献吻]':'[献吻]',
  '[左太极]':'[左太极]',
  '[右太极]':'[右太极]',
  '[闭嘴]':'[闭嘴]',
  '[猫咪]':'[猫咪]',
  '[红双喜]':'[红双喜]',
  '[鞭炮]':'[鞭炮]',
  '[红灯笼]':'[红灯笼]',
  '[麻将]':'[麻将]',
  '[麦克风]':'[麦克风]',
  '[礼品袋]':'[礼品袋]',
  '[信封]':'[信封]',
  '[象棋]':'[象棋]',
  '[彩带]':'[彩带]',
  '[蜡烛]':'[蜡烛]',
  '[爆筋]':'[爆筋]',
  '[棒棒糖]':'[棒棒糖]',
  '[奶瓶]':'[奶瓶]',
  '[面条]':'[面条]',
  '[香蕉]':'[香蕉]',
  '[飞机]':'[飞机]',
  '[左车头]':'[左车头]',
  '[车厢]':'[车厢]',
  '[右车头]':'[右车头]',
  '[多云]':'[多云]',
  '[下雨]':'[下雨]',
  '[钞票]':'[钞票]',
  '[熊猫]':'[熊猫]',
  '[灯泡]':'[灯泡]',
  '[风车]':'[风车]',
  '[闹钟]':'[闹钟]',
  '[雨伞]':'[雨伞]',
  '[彩球]':'[彩球]',
  '[钻戒]':'[钻戒]',
  '[沙发]':'[沙发]',
  '[纸巾]':'[纸巾]',
  '[手枪]':'[手枪]',
  '[青蛙]':'[青蛙]',
}

export const emojiKeyMapping: any = {
  '[微笑]': '[TUIEmoji_Smile]',
  '[期待]': '[TUIEmoji_Expect]',
  '[眨眼]': '[TUIEmoji_Blink]',
  '[大笑]': '[TUIEmoji_Guffaw]',
  '[姨母笑]': '[TUIEmoji_KindSmile]',
  '[哈哈哈]': '[TUIEmoji_Haha]',
  '[愉快]': '[TUIEmoji_Cheerful]',
  '[无语]': '[TUIEmoji_Speechless]',
  '[惊讶]': '[TUIEmoji_Amazed]',
  '[悲伤]': '[TUIEmoji_Sorrow]',
  '[得意]': '[TUIEmoji_Complacent]',
  '[傻了]': '[TUIEmoji_Silly]',
  '[色]': '[TUIEmoji_Lustful]',
  '[憨笑]': '[TUIEmoji_Giggle]',
  '[亲亲]': '[TUIEmoji_Kiss]',
  '[大哭]': '[TUIEmoji_Wail]',
  '[哭笑]': '[TUIEmoji_TearsLaugh]',
  '[困]': '[TUIEmoji_Trapped]',
  '[口罩]': '[TUIEmoji_Mask]',
  '[恐惧]': '[TUIEmoji_Fear]',
  '[龇牙]': '[TUIEmoji_BareTeeth]',
  '[发怒]': '[TUIEmoji_FlareUp]',
  '[打哈欠]': '[TUIEmoji_Yawn]',
  '[机智]': '[TUIEmoji_Tact]',
  '[星星眼]': '[TUIEmoji_Stareyes]',
  '[闭嘴]': '[TUIEmoji_ShutUp]',
  '[叹气]': '[TUIEmoji_Sigh]',
  '[呵呵]': '[TUIEmoji_Hehe]',
  '[收声]': '[TUIEmoji_Silent]',
  '[惊喜]': '[TUIEmoji_Surprised]',
  '[白眼]': '[TUIEmoji_Askance]',
  '[OK]': '[TUIEmoji_Ok]',
  '[便便]': '[TUIEmoji_Shit]',
  '[怪兽]': '[TUIEmoji_Monster]',
  '[恶魔]': '[TUIEmoji_Daemon]',
  '[恶魔怒]': '[TUIEmoji_Rage]',
  '[衰]': '[TUIEmoji_Fool]',
  '[猪]': '[TUIEmoji_Pig]',
  '[牛]': '[TUIEmoji_Cow]',
  '[AI]': '[TUIEmoji_Ai]',
  '[骷髅]': '[TUIEmoji_Skull]',
  '[炸弹]': '[TUIEmoji_Bombs]',
  '[咖啡]': '[TUIEmoji_Coffee]',
  '[蛋糕]': '[TUIEmoji_Cake]',
  '[啤酒]': '[TUIEmoji_Beer]',
  '[花]': '[TUIEmoji_Flower]',
  '[瓜]': '[TUIEmoji_Watermelon]',
  '[壕]': '[TUIEmoji_Rich]',
  '[爱心]': '[TUIEmoji_Heart]',
  '[月亮]': '[TUIEmoji_Moon]',
  '[太阳]': '[TUIEmoji_Sun]',
  '[星星]': '[TUIEmoji_Star]',
  '[红包]': '[TUIEmoji_RedPacket]',
  '[庆祝]': '[TUIEmoji_Celebrate]',
  '[福]': '[TUIEmoji_Bless]',
  '[发]': '[TUIEmoji_Fortune]',
  '[服]': '[TUIEmoji_Convinced]',
  '[禁]': '[TUIEmoji_Prohibit]',
  '[666]': '[TUIEmoji_666]',
  '[857]': '[TUIEmoji_857]',
  '[刀]': '[TUIEmoji_Knife]',
  '[赞]': '[TUIEmoji_Like]'
}

const emojiConfig = {
  emojiBaseUrl,
  emojiUrlMapping,
  emojiNameMapping,
  emojiKeyMapping
}
export { emojiConfig }
